
import React from 'react';
import business_logo from './images/logo/whitelogo.png';
import business_logo_dark from './images/logo/blacklogo.png';
import hero_bg_image from './images/demo-it-business-banner-bg.jpg';
import demo_it_business_icon from "./images/demo-it-business-icon-01.gif";
import demo_it_business_icontWO from "./images/demo-it-business-icon-02.gif";
import demo_it_business_icontHREE from "./images/demo-it-business-icon-03.gif";
import demo_it_business_One from "./images/demo-it-business-01.jpg";
import demo_it_business_two from "./images/demo-it-business-02.jpg";
import demo_it_business_three from "./images/demo-it-business-03.jpg";
import demo_it_business_four from "./images/demo-it-business-04.jpg";
import demo_it_business_five from "./images/demo-it-business-05.jpg";
import demo_it_business_six from "./images/demo-it-business-06.jpg";
import demo_it_business_seven from "./images/demo-it-business-07.jpg";
import demo_it_business_eight from "./images/demo-it-business-08.jpg";
// import demo_it_business_six from "./images/demo-it-business-06.jpg";
import walmart from './images/logo-walmart-dark-blue.svg';
import netflix from './images/logo-netflix-dark-blue.svg';
import invision from './images/logo-invision-dark-blue.svg';
import yahoo from './images/logo-yahoo-dark-blue.svg';
import amazon from './images/logo-amazon-dark-blue.svg';
import bg_circle from './images/demo-corporate-03.png';
import Cr_vision from './images/demo-corporate-01.png';
import trophy from './images/demo-corporate-02.png';
import b_testimonial from './images/demo-it-business-testimonial-bg.png';
import testimonial01 from './images/demo-it-business-testimonials-01.png';
import testimonial02 from './images/demo-it-business-testimonials-02.png';
import testimonial03 from './images/demo-it-business-testimonials-03.png';
import logitech from "./images/logo-loitech-dark-blue.svg";
import monday from "./images/logo-monday-dark-blue-01.svg";
import b_portfolio from "./images/demo-it-business-portfolio-01.jpg";
import b_portfolio1 from "./images/demo-it-business-portfolio-02.jpg";
import b_portfolio2 from "./images/demo-it-business-portfolio-03.jpg";
import b_portfolio3 from "./images/demo-it-business-portfolio-04.jpg";
import b_portfolio4 from "./images/demo-it-business-portfolio-05.jpg";
import b_portfolio5 from "./images/demo-it-business-portfolio-06.jpg";
import pyramid from "./images/demo-corporate-10.png";
import about_bg from "./images/demo-it-business-about-title-bg.jpg";
import about_slider_bg from "./images/demo-corporate-about-bg-01.png";
import about_img from './images/demo-corporate-about-img-01.jpg';
import aboit_img2 from "./images/demo-corporate-about-01.png";
import services from './images/demo-it-business-services-title-bg.jpg';
import contact from "./images/demo-it-business-contact-title-bg.jpg";
import contact2 from "./images/demo-yoga-and-meditation-contact-01.jpg";
import contact3 from "./images/demo-yoga-and-meditation-contact-03.jpg";
import contact4 from "./images/demo-yoga-and-meditation-contact-03.jpg";
import career from './images/demo-it-business-case-studies-title-bg.jpg';

const assets = () => {
  return {
    business_logo,
    business_logo_dark,
    hero_bg_image,
    demo_it_business_icon,
    demo_it_business_icontWO,
    demo_it_business_three,
    demo_it_business_four,
    demo_it_business_five,
    demo_it_business_six,
    demo_it_business_seven,
    demo_it_business_eight,
    demo_it_business_icontHREE,
    demo_it_business_One,
    demo_it_business_two,
    walmart,
    netflix,
    invision,
    amazon,
    yahoo,
    bg_circle,
    Cr_vision,
    trophy,
    b_testimonial,
    testimonial01,
    testimonial02,
    testimonial03,
    logitech,
    monday,
    b_portfolio,
    b_portfolio1,
    b_portfolio2,
    b_portfolio3,
    b_portfolio4,
    b_portfolio5,
    pyramid,
    about_bg,
    about_slider_bg,
    about_img,
    aboit_img2,
    services,
    contact,
    contact2,
    contact3,
    contact4,
    career,
  };
};

export default assets;
